import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import classNames from 'classnames';
import React from 'react';
import { bsClass, getClassSet, splitBsProps } from "./utils/bootstrapUtils";
var ButtonToolbar = function (_React$Component) {
  _inherits(ButtonToolbar, _React$Component);
  function ButtonToolbar() {
    _classCallCheck(this, ButtonToolbar);
    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
      className = _props.className,
      props = _objectWithoutProperties(_props, ['className']);
    var _splitBsProps = splitBsProps(props),
      bsProps = _splitBsProps[0],
      elementProps = _splitBsProps[1];
    var classes = getClassSet(bsProps);
    return /*#__PURE__*/React.createElement('div', _extends({}, elementProps, {
      role: 'toolbar',
      className: classNames(className, classes)
    }));
  };
  return ButtonToolbar;
}(React.Component);
export default bsClass('btn-toolbar', ButtonToolbar);